/**
 * クイズ背景のグラデーションカラー
 * MEDULLA風のやさしいパステルカラー
 * Figmaデザイン（node-id=219-542）から抽出したカラーパレット
 */
export const QUIZ_GRADIENT_COLORS = [
  '#FFB6C1', // ライトピンク（ベビーピンク）
  '#FFDAB9', // ピーチパフ（淡いオレンジ/ピーチ）
  '#B0E0E6', // パウダーブルー（明るいスカイブルー）
  '#F0E6F0', // 非常に淡いライラック（控えめなパープル）
];
